export default "__VITE_ASSET__Gmg1FSJj__"